import { useEffect, useState } from 'react'
import { Box } from '@mui/system'
import { Typography } from '@mui/material'
import { useDispatch } from 'react-redux'
import OfoqPasswordField from '../../../components/Forms/OfoqPasswordField'
import OfoqThemeBtn from '../../../components/Buttons/OfoqThemeBtn'
import { isNotEmpty } from '../../../utils/helpers'
import UseTranslation from '../../../hooks/UseTranslation'
import { userResetPassword } from '../../../redux/features/userAuth/userAuthThunk'

const Form = ({ setResetPasswordSuccess, token }) => {
  const dispatch = useDispatch()
  const { t } = UseTranslation()
  const [newPassword, setNewPassword] = useState(null)
  const [repeatPassword, setRepeatPassword] = useState(null)
  const [validPassword, setValidPassword] = useState(false)
  const [isFormNotValid, setIsFormNotValid] = useState(true)

  const isMatch = isNotEmpty(newPassword) && isNotEmpty(repeatPassword) &&
  newPassword === repeatPassword;

  useEffect(() => {
    setIsFormNotValid(validPassword && isMatch)
  }, [newPassword, repeatPassword, validPassword])

  const submitHandler = async () => {
    dispatch(
      userResetPassword({
        queries: {
          new_password: newPassword,
          token,
        },
      }),
    ).then((res) => {
      if (res?.meta?.requestStatus === 'fulfilled') {
        setResetPasswordSuccess(true)
      }
    })
  }

  return (
        <Box sx={styles.leftSideContainer}>
          <Typography variant={'h4'} sx={styles.formTitle}>
             {t?.['Reset Password']}
          </Typography>

          <Typography component={'p'} sx={styles.formSubTitle}>{t?.['Please add the new password you need to set for your account']}</Typography>

          <form style={styles.formContainer}>
            <OfoqPasswordField
          defaultValue={newPassword}
          refState={setNewPassword}
          placeholder={t?.['Enter the new password']}
          name={t?.['new password']}
          setValidPassword={setValidPassword}
          hideInputValidator={false}
          required
          customStyle={styles.passwordInput}
          />

            <OfoqPasswordField
              defaultValue={repeatPassword}
              refState={setRepeatPassword}
              placeholder={t?.['Repeat the New Password']}
              name={t?.['Repeat New Password']}
              hideInputValidator
              passwordMatch={isMatch}
              required
              customStyle={styles.passwordInput}
            />

            <Box sx={styles.formBtns}>
              <OfoqThemeBtn customStyle={styles.continueBtn(isFormNotValid)}
                 name={t?.save}
                 onClick={(e) => submitHandler(e)}
                 disabled={!isFormNotValid}
              />
            </Box>
          </form>
        </Box>

  )
}
const styles = {

  leftSideContainer: {
    boxSizing: 'border-box',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: { xs: 'center', sm: 'flex-start' },
    maxWidth: { xs: '100%', sm: '500px', md: '620px' },
    width: '100%',
    maxHeight: '336px',
    height: '100%',
    marginTop: { xs: '60px', sm: '20px', md: '70px' },
    marginLeft: { xs: '0px', md: '30px' },
    px: '10px',
    zIndex: '2',
  },

  formContainer: {
    display: 'flex',
    flexDirection: 'column',
    maxWidth: { xs: '100%', sm: '400px', lg: '5500px' },
    marginTop: { xs: '0px', sm: '20px' },
  },

  formTitle: {
    color: 'primary.contrastText',
    marginBottom: { xs: '10px', sm: '5px' },
    fontSize: { xs: '20px', sm: '28px' },
    textAlign: { xs: 'unset', sm: 'left' },
    lineHeight: { xs: '25px', sm: '43.74px' },
    fontWeight: 600,
    my: { xs: '15px', sm: '10px' },
  },
  formSubTitle: {
    fontSize: { xs: '14px', sm: '16px' },
    mb: { xs: '15px', sm: '40px' },
    fontWeight: 400,
  },
  formBtns: {
    display: 'flex',
    minWidth: '100%',
    justifyContent: { xs: 'center', sm: 'flex-end' },
    marginTop: { xs: '10px', sm: '-15px' },
  },
  continueBtn: (isFormNotValid) => ({
    maxWidth: { xs: '100%', sm: '189px' },
    height: '40px',
    color: 'white !important',
    background: isFormNotValid ? 'primary.main' : 'rgba(41, 204, 139, 0.5)',
  }),
  errorContainer: {
    width: '100%',
    marginBottom: '30px',
  },
  passwordInput: {
    '& .password-label': {
      fontSize: '14px',
      fontWeight: 300,
    },
    '& .password-field': {
      height: '50px',
      mb: { xs: '0px', sm: '10px' },
    },
    '& .password-requirements': {
      fontSize: '12px',
    },
  },
}

export default Form
